// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"7c101e48","553":"f5e67265","603":"4ec3528a","701":"c5b7e5b6","788":"d34cb71c","891":"2ea41c34"}[chunkId] + ".chunk.js";
};